import React from 'react';
import { Link } from 'react-router-dom';
import LiveGoldRate from '../components/admin/LiveGoldRate';
import '../styles/common.css';
import '../styles/Admin/LiveGoldRate.css';

const LiveGoldRatePage = () => {
  return (
    <div className="page-container">
      <div className="page-header">
        <h2>Live Gold & Silver Rates</h2>
        <p>Get real-time gold and silver prices in Indian Rupees</p>
      </div>

      <div className="live-rates-container">
        <LiveGoldRate />
      </div>

      {/* Gold Investment Tracker Banner */}
      <div style={{
        maxWidth: '900px',
        margin: '40px auto 60px',
        padding: '0 20px',
      }}>
        <Link to="/gold-investment-tracker" style={{ textDecoration: 'none' }}>
          <div style={{
            background: 'linear-gradient(135deg, #1a1209 0%, #3d2b0e 60%, #5c3d11 100%)',
            borderRadius: '16px',
            padding: '28px 32px',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: '20px',
            flexWrap: 'wrap',
            boxShadow: '0 8px 32px rgba(184,134,11,0.25)',
            border: '1px solid rgba(245,216,140,0.2)',
            cursor: 'pointer',
            transition: 'transform 0.2s, box-shadow 0.2s',
          }}
            onMouseEnter={e => { e.currentTarget.style.transform = 'translateY(-2px)'; e.currentTarget.style.boxShadow = '0 12px 40px rgba(184,134,11,0.35)'; }}
            onMouseLeave={e => { e.currentTarget.style.transform = 'none'; e.currentTarget.style.boxShadow = '0 8px 32px rgba(184,134,11,0.25)'; }}
          >
            <div style={{ display: 'flex', alignItems: 'center', gap: '16px' }}>
              <span style={{ fontSize: '2.5rem' }}>📈</span>
              <div>
                <div style={{ color: '#F5D88C', fontFamily: 'Playfair Display, serif', fontSize: '1.3rem', fontWeight: '700', marginBottom: '4px' }}>
                  Know What Your Gold Is Worth Today
                </div>
                <div style={{ color: 'rgba(245,216,140,0.75)', fontSize: '0.9rem' }}>
                  Enter your mobile number or calculate manually — see real gains on every piece you own.
                </div>
              </div>
            </div>
            <div style={{
              background: '#B8860B',
              color: '#fff',
              padding: '12px 24px',
              borderRadius: '8px',
              fontWeight: '700',
              fontSize: '0.95rem',
              whiteSpace: 'nowrap',
              flexShrink: 0,
            }}>
              Check My Portfolio →
            </div>
          </div>
        </Link>
      </div>
    </div>
  );
};

export default LiveGoldRatePage;
